import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-export-application-smart',
  templateUrl: './export-application-smart.component.html',
  styleUrls: ['./export-application-smart.component.scss']
})
export class ExportApplicationSmartComponent implements OnInit {

  @Input() disabled = false;
  @Input() type: 'csv' | 'xml' = 'csv';
  @Input() icon = 'cloud_download';
  @Input() color = 'primary';
  @Input() dealId: number;

  constructor() { }

  ngOnInit(): void {
  }

}
